var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102.197,
    height: 71.152,
    viewBox: "0 0 102.197 71.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.085,
    y1: 1,
    x2: 0.973,
    y2: -0.175,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1711",
    "data-name": "Trac\\xE9 1711",
    d: "M111.791,147.654a9.676,9.676,0,0,1-6.943-2.922l-26.95-27.6a9.7,9.7,0,0,1,13.886-13.56l20.344,20.837L161.04,79.089A9.7,9.7,0,1,1,174.228,93.32L118.384,145.07A9.663,9.663,0,0,1,111.791,147.654Z",
    transform: "translate(-75.139 -76.503)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationIcon);
export default __webpack_public_path__ + "static/media/validationIcon.196214b31cbc4654246502403131fa34.svg";
export { ForwardRef as ReactComponent };